<template>
    <div>
        <div class="b-sidebar-backdrop bg-dark" style="z-index: 100" v-if="isSideBarVisible" @click="HideSideBar" ref="BackDrop"></div>
        <b-sidebar
            id="PIGDetailPopUp"
            class="customSidebar"
            right
            bg-variant="white" 
            :shadow="true"
            v-model="isSideBarVisible"
            ref="newsRightpopup"
            :no-header-close="true"
            :no-close-on-esc="true"
            :no-close-on-route-change="true">
            <router-view ref="currentItem"></router-view>
        </b-sidebar>
    </div>
</template>

<script>
export default{
    data(){
        return{
            isSideBarVisible : this.$route.name === "PIGDetail",
        }
    },
    computed: {
        currentRouteName() {
            return this.$route.name;
        },
    },
    methods:{
        HideSideBar(){
            this.$refs.currentItem.onCloseDetail();
        },
    },
    watch:{
        currentRouteName: {
            handler() {
                this.$nextTick(() => {
                    const isDetailOpened = this.currentRouteName === "PIGDetail";

                    this.isSideBarVisible = isDetailOpened;

                    // Force background to be not scrollable
                    if (isDetailOpened) {
                        document.body.style.overflow = "hidden";
                    } else {
                        document.body.style.overflowY = "scroll";
                    }
                });
            },
        },
    }
}

    

</script>